import { Injectable, OnInit } from '@angular/core';
import { HttpClientWrapper } from './httpclientwrapper';
import { Observable, of } from "rxjs";
import { AddressType } from '../models/addressType';
import { Country } from '../models/country';
import { Currency } from '../models/currency';
import { Duration } from '../models/duration';
import { EducationLevel } from '../models/educationLevel';
import { EmailType } from '../models/emailType';
import { Jobcategory } from '../models/jobcategory';
import { Jobsource } from '../models/jobsource';
import { Jobtype } from '../models/jobtype';
import { Language } from '../models/language';
import { Martialstatus } from '../models/martialstatus';
import { Phonetype } from '../models/phonetype';
import { Priority } from '../models/priority';
import { Sector } from '../models/sector';
import { Stateprovince } from '../models/stateprovince';
import { Webtype } from '../models/webtype';
import { Positiontype } from '../models/positiontype';
import { JobLevel } from '../models/jobLevel';
import { Fluency } from '../models/fluency';
import { DrivingLicenseType } from '../models/drivingLicenseType';
import { Gender } from '../models/gender';
import { SchoolType } from '../models/schooltype';
import { DegreeType } from '../models/degreetype';
import { SkillType } from '../models/skilltype';
import { CvsearchRequestCvage } from '../models/cvsearch-request-cvage';
import { CvsearchRequestFrequency } from '../models/cvsearch-request-frequency'
import { Attbalertfrequency } from '../models/attbalertfrequency';
import { CandidateType } from '../models/cvsearchresult';
import { CvFeedBackType } from '../models/cv-feed-back-type';
import { CvSuitabilityType } from '../models/cv-suitability-type';
import { Location, Region } from '../models/location';
import { SalaryRange } from '../models/SalaryRage';
import { CvLibraryCountyLocation } from '../models/cvLibraryCountyLocation';
import { EmailFrequency } from "../models/emailfrequency";
import { EmploymentStatus } from '../models/EmploymentStatus';
import { AgeRanges } from '../models/age-ranges';
import { PostType } from '../models/postType';
import { DashboardType } from '../models/dashboard-type';
import { UserEmailEventsTypes } from '../models/userEmailEventtypes';
import { tap } from 'rxjs/operators';
import { AgeRange } from '../models/AgeRange';
import { VerifiedStatus } from '../models/VerifiedStatus';
import { UserTitle } from '../models/UserTitle';
import { Badge} from '../models/badge';
import { BadgeType} from '../models/badgeType';
import { IsAny } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { ReferenceRelationType } from '@apply4u/models/reference-relation-type';
import { KeyValue } from '@angular/common';
import { KeyValueStrings } from '@apply4u/models/common/key-value-pair';

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
    private cachedData: Map<string, any>;

    constructor(private http: HttpClientWrapper) {

        this.cachedData = new Map<string, any>();
    }

    baseUrl: string = "api/MasterData/";

    GetPostTypes(): Observable<PostType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "PostTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<PostType[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }

    GetCvLibraryCountyLocation(): Observable<CvLibraryCountyLocation[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CvLibrary/Counties";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<CvLibraryCountyLocation[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    GetSalaryRanges(): Observable<SalaryRange[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "SalaryRanges";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }
        return this.http.GetAsync<SalaryRange[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getCandidateTypes(): Observable<CandidateType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CandidateTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<CandidateType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getAlertFrequencies(): Observable<Attbalertfrequency[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "alertfrequencies";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Attbalertfrequency[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getCVSearchRequestFrequencies(): Observable<CvsearchRequestFrequency[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CVSearchRequestFrequency";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }
        return this.http.GetAsync<CvsearchRequestFrequency[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getCVSearchRequestCVAge(): Observable<CvsearchRequestCvage[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CVSearchRequestCVAge";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<CvsearchRequestCvage[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    GetEmailFrequency(): Observable<EmailFrequency[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "EmailFrequencies";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<EmailFrequency[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getGender(): Gender[] {

        return [
            {
                Id: 1,
                Description: "Male",
                EnumKey: "Male"
            }
            ,
            {
                Id: 2,
                Description: "Female",
                EnumKey: "Female"
            },
            {
                Id: 3,
                Description: "Other",
                EnumKey: "Other"
            },
            {
                Id: 4,
                Description: "Prefer not to say",
                EnumKey: "Prefernottosay"
            }
        ]
    }

    getMenuLocation(): Observable<Region[]> {

        let requestUrl = this.http.BaseUrl + "api/Location/MenuLocations";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Region[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }


    getSkillType(): Observable<SkillType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "SkillTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<SkillType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getDegreeTypes(): Observable<DegreeType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "DegreeTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }


        return this.http.GetAsync<DegreeType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getSchoolType(): Observable<SchoolType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "SchoolTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<SchoolType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getDrivingLicenseType(): Observable<DrivingLicenseType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "DrivingLicenseTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<DrivingLicenseType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getFluency(): Observable<Fluency[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Fluency";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Fluency[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getJobLevel(): Observable<JobLevel[]> {


        let requestUrl = this.http.BaseUrl + this.baseUrl + "JobLevels";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<JobLevel[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getAddressTypes(): Observable<AddressType[]> {


        let requestUrl = this.http.BaseUrl + this.baseUrl + "AddressTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<AddressType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getCountries(): Observable<Country[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Countries";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Country[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getCurrency(): Observable<Currency[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Currencies";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Currency[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getDuration(): Observable<Duration[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Durations";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Duration[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));

    }

    getEducationLevel(): Observable<EducationLevel[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "EducationLevels";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<EducationLevel[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getEmailType(): Observable<EmailType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "EmailTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<EmailType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getJobCategory(): Observable<Jobcategory[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "JobCategories";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Jobcategory[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getJobSource(): Observable<Jobsource[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "JobSources";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Jobsource[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getJobType(): Observable<Jobtype[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "JobTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Jobtype[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getLanguage(): Observable<Language[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Languages";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }


        return this.http.GetAsync<Language[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getMartialStatus(): Observable<Martialstatus[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "MartialStatuses";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Martialstatus[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getPhoneType(): Observable<Phonetype[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "PhoneTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Phonetype[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getPriority(): Observable<Priority[]> {

        return this.http.GetAsync<Priority[]>(this.baseUrl + "Priorities");
    }

    getSector(parentSectorId: number): Observable<Sector[]> {
        let requesPramasUrl = "?";

        if (parentSectorId != null && parentSectorId > 0) {

            requesPramasUrl += (requesPramasUrl == "?" ? "" : "&") + "parentId=" + parentSectorId;
        }

        if (requesPramasUrl == "?") {
            requesPramasUrl = this.baseUrl + "Sectors";
        } else {

            requesPramasUrl = this.baseUrl + "Sectors" + requesPramasUrl;

        }

        const cache = this.cachedData.get(this.http.BaseUrl + requesPramasUrl);

        if (cache) {
            return of(cache);
        }

        return this.http.GetAsync<Sector[]>(this.http.BaseUrl + requesPramasUrl)
            .pipe(tap(res => {

                this.cachedData.set(this.http.BaseUrl + requesPramasUrl, res);
            }));
    }

    getAllSectors(): Observable<Sector[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "sectors/all";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Sector[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    GetAllRefinedSectors(): Observable<Sector[]> {

        let requestUrl = this.http.BaseUrl + "api/Sectors/all";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Sector[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getStateProvince(): Observable<Stateprovince[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "StateProvinces";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Stateprovince[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getWebType(): Observable<Webtype[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "WebTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Webtype[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    getPositionType(): Observable<Positiontype[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "PositionTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }
        return this.http.GetAsync<Positiontype[]>(requestUrl)
            .pipe(tap(res => {
                if (IsAny(res)) {
                    res = res.sort(function(x,y){ return x.Id == 8 ? -1 : y.Id == 8 ? 1 : 0; });
                }

                this.cachedData.set(requestUrl, res);
            }));
    }

    getCvSuitabilityTypes(): Observable<CvSuitabilityType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CvSuitabilityTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<CvSuitabilityType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getCvFeedbackTypes(): Observable<CvFeedBackType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "CvFeedbackTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<CvFeedBackType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    GetEmploymentStatusTypes(): Observable<EmploymentStatus[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "employmentStatus";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<EmploymentStatus[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getSectorById(sectorId: number): Observable<Sector> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "sectors/" + sectorId;

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Sector>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    getAgeRanges() {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "ageRanges";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }


        return this.http.GetAsync<AgeRanges[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }

    GetDashboardTypes() {
        let requestUrl = this.http.BaseUrl + this.baseUrl + "DashboardTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }
        return this.http.GetAsync<DashboardType[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
    GetEmailEventTypes(): Observable<UserEmailEventsTypes[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "EmailEventTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }
        return this.http.GetAsync<UserEmailEventsTypes[]>(requestUrl)
            .pipe(tap(res => {
                this.cachedData.set(requestUrl, res);
            }));
    }
 

    getAgeRange(): Observable<AgeRange[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "AgeRange";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<AgeRange[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }

    getVerifiedStatus(): Observable<VerifiedStatus[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "ProfileVerificationType";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<VerifiedStatus[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }
    getUserTitle(): Observable<UserTitle[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "ProfileTitleType";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<UserTitle[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }

    getUserBadge(): Observable<Badge[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "Badges";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<Badge[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }

    getUserBadgeTypes(): Observable<BadgeType[]> {

        let requestUrl = this.http.BaseUrl + this.baseUrl + "BadgeTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {

            return of(cached);
        }

        return this.http.GetAsync<BadgeType[]>(requestUrl)
            .pipe(tap(res => {

                this.cachedData.set(requestUrl, res);
            }));
    }


    GetParentSectorByChildSectorName(sectorname: string): Observable<Sector> {
        return this.http.GetAsync<Sector>(this.http.BaseUrl + "api/Sectors/sectorName?sectorName=" +sectorname);
    }

    GetLocationHierarchyAsync(locationName: string): Observable<KeyValueStrings[]> {
        return this.http.GetAsync<KeyValueStrings[]>(this.http.BaseUrl + "api/Location/locationHierarchy?locationName=" +locationName);
    }
   
    GetSectorBySeoName(seoSectorName: string): Observable<Sector> {
        let requestUrl = `${this.http.BaseUrl}api/Sectors/seo/${seoSectorName}`;

        const cached = this.cachedData.get(requestUrl);

        if (cached) {
            return of(cached);
        }

        return this.http.GetAsync<Sector>(requestUrl).pipe(tap(res => {
            this.cachedData.set(requestUrl, res);
        }));
    }

    GetReferenceRelationTypes(): Observable<ReferenceRelationType[]> {
        let requestUrl = this.http.BaseUrl + this.baseUrl + "ReferenceRelationTypes";

        const cached = this.cachedData.get(requestUrl);

        if (cached) {
            return of(cached);
        }

        return this.http.GetAsync<ReferenceRelationType[]>(requestUrl).pipe(tap(res => {
            this.cachedData.set(requestUrl, res);
        }));
    }
}